import { gql } from '@apollo/client';

export const ADD_UPDATE_SCORING_CATEGORY = gql`
  mutation addOrUpdateScoringCategory($defaultDetailId: Int, $input: ScoringCategoryItemInput) {
    addOrUpdateScoringCategory(defaultDetailId: $defaultDetailId, input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_SCORING_CATEGORY_DETAIL = gql`
  mutation addOrUpdateScoringCategoryDetail($input: ScoringCategoryDetailItemInput) {
    addOrUpdateScoringCategoryDetail(input: $input) {
      commandId
    }
  }
`;

export const DELETE_SCORING_CATEGORY_DETAIL = gql`
  mutation deleteScoringCategoryDetail($input: DeleteScoringCategoryDetailInput) {
    deleteScoringCategoryDetail(input: $input) {
      commandId
    }
  }
`;
